import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as toast from "../../../utils/makeToast";
import { useDispatch } from "react-redux";
import { IBankBranch } from "../../../models/IEnums.model";
import { baseUrl } from "../../../utils/baseUrl";
import uploadArrow from "../../../assets/images/upload-arrow.svg";
import pen from "../../../assets/images/pen.svg";
import camera from "../../../assets/images/camera.svg";
import { getLocalStorageItem } from "../../../utils/localStorage";
import closeIcon from "../../../assets/images/close-icon.svg";
import { setAccountOpeningStep } from "../../../redux/accountOpening";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { trimBase64ImgUrl, trimImageURI } from "../../../utils/imageUpload";
import {
  links,
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
} from "../../../utils/constants";
import "youverify-web-sdk";
import Icon_L from "../../../assets/images/Icon_L.svg";
import FileUpload from "../../FileUpload";
import Select from "react-select";
import CameraComponent from "../../CameraComponent";
import { returnConfigVariable } from "../../../utils/helpers";

function ExUploadDocumentsMinorSavings(props: any) {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      // branchOfDomiciliation: 0
      branchOfDomiciliation: 0,
      terms: "",
      debitCardValueAddedService: "",
      debitCardDeliveryAddress: "",
      debitCardType: "master_card",
    },
    onSubmit: (values) => {
      uploadDcouments(values);
    },
  });

  const [updating, setUpdating] = useState(false);

  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [idCardUrl, setIdCardUrl] = useState("");
  const [minorImageUrl, setMinorImageUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [minorIdentityUrl, setMinorIdentityUrl] = useState("");
  const [utilityBillImageUrl, setutilityBillImageUrl] = useState("");
  const [selectedBranch, setSelectedBranch] = useState<any>();
  const [mappedBranches, setMappedBranches] = useState([]);

  const [signatureImageBase64, setSignatureImageBase64] = useState("");
  const [idCardBase64, setIdCardBase64] = useState("");
  const [minorImageBase64, setMinorImageBase64] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const [minorIdentityBase64, setMinorIdentityBase64] = useState("");
  const [utilityBillImageBase64, setUtilityBillImageBase64] = useState("");

  const [settingSignatureImage, setSettingSignatureImage] =
    useState<boolean>(false);
  const [settingIdCardImage, setSettingIdCardImage] = useState<boolean>(false);
  const [settingMinorImage, setSettingMinorImage] = useState<boolean>(false);
  const [settingImage, setSettingImage] = useState<boolean>(false);
  const [settingMinorIdentityImage, setSettingMinorIdentityImage] =
    useState<boolean>(false);
  const [settingutilityBillImage, setSettingUtilityBillImage] =
    useState<boolean>(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const [userExistingDetails, setUserExistingDetails] = useState<any>();
  const [bvnValidationData, setBvnValidationData] = useState(
    getLocalStorageItem("bvnValidationData")
  );

  const [showCamera, setShowCamera] = useState<boolean>(false);
  const [livePictureDocumentName, setLivePictureDocumentName] =
    useState<string>("");
  const [bankBranches, setBankBranches] = useState<IBankBranch[]>([]);

  const getBankBranches = () => {
    axios
      .get(`${baseUrl}Enum/BranchCodeList`)
      .then((response) => {
        setBankBranches(response.data);

        let tempBranches = response.data;
        tempBranches = response.data.map((branch: IBankBranch) => {
          return {
            label: branch.branch,
            value: branch.brancH_CODE,
          };
        });
        setMappedBranches(tempBranches);
      })
      .catch((err) => {
        
      });
  };

  const handleSelectBranch = (data: any) => {
    setSelectedBranch(data);
  };

  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  let fileUploadObj: any;

  const uploadDcouments = (values: any) => {
    let uploadDocumentPayload = {
      id: getLocalStorageItem("minorId"),
      // signatureUrl: trimBase64ImgUrl(signatureImageUrl),
      // idCardUrl: trimBase64ImgUrl(idCardUrl),
      // minorImageUrl: trimBase64ImgUrl(minorImageUrl),
      // imageUrl: trimBase64ImgUrl(imageUrl),
      // minorIdentityUrl: trimBase64ImgUrl(minorIdentityUrl),
      signatureUrl: signatureImageUrl,
      utilityBill: utilityBillImageUrl,
      idCardUrl: idCardUrl,
      minorImageUrl: minorImageUrl,
      imageUrl: imageUrl,
      minorIdentityUrl: minorIdentityUrl,

      accountTypecode: localStorage.getItem("altFinanceGlCode"),
      accountTypeName: localStorage.getItem("altFinanceAccountType"),
      debitCardDeliveryAddress: values.debitCardDeliveryAddress,
      occupationName: "",
      isFlagged: bvnValidationData.isFlagged,

      branchOfDomiciliation: userExistingDetails?.branchOfDomiciliation || 1,
      termsCondition: true,
    };
    if (!uploadDocumentPayload.minorImageUrl) {
      toast.errorToast("Please upload Minor's Passport Photo");
      return;
    }

    if (!uploadDocumentPayload.idCardUrl) {
      toast.errorToast("Please upload Parent/ Guardian Id Card");
      return;
    }
    if (!uploadDocumentPayload.utilityBill) {
      toast.errorToast("Please provide a Utility Bill");
      return;
    }
    if (!uploadDocumentPayload.minorIdentityUrl) {
      toast.errorToast(
        "Please upload Minor's Birth certificate/NIN/International passport"
      );
      return;
    }

    if (!uploadDocumentPayload.branchOfDomiciliation) {
      toast.errorToast("Please select a branch of account domiciliation");
      return;
    }

    if (!values.terms) {
      toast.errorToast("Please accept terms and conditions");
      return;
    }
    
    // return
    setUpdating(true);
    axios
      .post(`${baseUrl}MinorSavings/documentupload`, uploadDocumentPayload)
      .then((response) => {
        
        setUpdating(false);
        if (!response?.data?.isSuccess) {
          toast.errorToast(`${response?.data?.message}`);
          return;
        }
        localStorage.setItem(
          "generatedAccountNumber",
          response?.data?.obj?.accountNo
        );
        dispatch(setAccountOpeningStep("account-opening-success"));
      })
      .catch((err) => {
        
        setUpdating(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  const getExistingDetails = () => {
    axios
      .get(`${baseUrl}MinorSavings/existingDetails?bvn=${userDetails.bvn}`)
      .then((response) => {
        
        setUserExistingDetails(response?.data);
      })
      .catch((err) => {
        
      });
  };

  useEffect(() => {
    getExistingDetails();
    getBankBranches();
  }, []);

  const uploadImage = (payload: any, type: string) => {
    
    if (type == "parentSignature") {
      setSignatureImageBase64(payload.postedFilebase64);
      setSettingSignatureImage(true);
    } else if (type == "minorSelfie") {
      setMinorImageBase64(payload.postedFilebase64);
      setSettingMinorImage(true);
    } else if (type === "utilityBill") {
      setUtilityBillImageBase64(payload.postedFilebase64);
      setSettingUtilityBillImage(true);
    } else if (type == "parentPicture") {
      setImageBase64(payload.postedFilebase64);
      setSettingImage(true);
    } else if (type == "parentFrontPageId") {
      setIdCardBase64(payload.postedFilebase64);
      setSettingIdCardImage(true);
    } else if (type == "minorIdentity") {
      setMinorIdentityBase64(payload.postedFilebase64);
      setSettingMinorIdentityImage(true);
    }
    // return
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        
        if (type == "parentSignature") {
          setSignatureImageUrl(response.data?.id);
          setSettingSignatureImage(false);
        } else if (type == "minorSelfie") {
          setMinorImageUrl(response.data?.id);
          setSettingMinorImage(false);
        } else if (type == "parentPicture") {
          // else if (type == 'image') {
          setImageUrl(response.data?.id);
          setSettingImage(false);
        } else if (type == "utilityBill") {
          
          setutilityBillImageUrl(response.data?.id);
          setSettingUtilityBillImage(false);
        } else if (type == "parentFrontPageId") {
          setIdCardUrl(response.data?.id);
          setSettingIdCardImage(false);
        } else if (type == "minorIdentity") {
          setMinorIdentityUrl(response.data?.id);
          setSettingMinorIdentityImage(false);
        }
      })
      .catch((err) => {
        
        setSettingSignatureImage(false);
        setSettingMinorImage(false);
        setSettingImage(false);
        setSettingIdCardImage(false);
        setSettingMinorIdentityImage(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message
        );
      });
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let fileReaderResult = fileReader.result?.toString();
        return resolve(fileReaderResult);
        // if (
        //     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'png' ||
        //     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'jpg' ||
        //     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'pdf'
        // ) {
        //     return resolve(fileReaderResult?.substring(22))
        // }
        // else if (
        //     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'jpeg'
        // ) {
        //     return resolve(fileReaderResult?.substring(23))
        // }
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let fileSize = file.size / 1000;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      

      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }
    if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
      toast.errorToast(
        `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`
      );
      return;
    }
    let base64: any;

    convertToBase64(file).then((res) => {
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleSubmit(type);
    });
  };

  // const handleFileUpload = async (e: any, type: string) => {
  //     const file = e.target.files[0];
  //     let fileSize = file.size/1000
  //     if(fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE){
  //     toast.errorToast(`File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`)
  //     return
  //     }
  //     let base64: any;

  //     convertToBase64(file)
  //         .then(res => {
  //             base64 = res
  //             fileUploadObj = {
  //                 postedFilebase64: res,
  //                 documentName: type,
  //                 filetype: file.type.split('/')[1]
  //             }
  //             if (type == 'parentSignature') {
  //                 setSignatureImageUrl("data:image/jpg;base64," + res)
  //             }
  //             else if (type == 'minorSelfie') {
  //                 setMinorImageUrl("data:image/jpg;base64," + res)
  //             }
  //             else if (type == 'parentPicture') {
  //                 setImageUrl("data:image/jpg;base64," + res)
  //             }
  //             else if (type == 'parentFrontPageId') {
  //                 setIdCardUrl("data:image/jpg;base64," + res)
  //             }
  //             else if (type == 'minorIdentity') {
  //                 setMinorIdentityUrl("data:image/jpg;base64," + res)
  //             }
  //         })
  // };

  const clearImage = (type: any) => {
    if (type === "parentSignature") {
      setSignatureImageUrl("");
    }
    if (type === "minorSelfie") {
      setMinorImageUrl("");
    }
    if (type === "parentPicture") {
      setImageUrl("");
    }
    if (type === "parentFrontPageId") {
      setIdCardUrl("");
    }
    if (type === "minorIdentity") {
      setMinorIdentityUrl("");
    }
    if (type === "utility-bill") {
      setutilityBillImageUrl("");
    }
  };

  const toggleCamera = (type: string, value: boolean) => {
    setLivePictureDocumentName(type);
    setShowCamera(value);
  };

  const handleTakePhoto = (dataUri: any) => {
    let res = trimImageURI(dataUri);
    setImageUrl("data:image/jpg;base64," + res);
    setShowCamera(false);
    fileUploadObj = {
      postedFilebase64: dataUri,
      documentName: livePictureDocumentName,
      filetype: "png",
    };
    handleSubmit(livePictureDocumentName);
    setShowCamera(false);
  };

  const handleCameraError = (error: any) => {
    toast.errorToast("Something went wrong, please try again");
  };

  const handleCameraStart = () => {
    // 
  };

  const handleCameraStop = () => {
    // 
  };

  const LivenessCheckClick = () => {
    // Initialize the Youverify Liveness Check module
    //@ts-ignore
    const YVSDK = window.YouverifySDK;
    
    const livenessCheckModule = new YVSDK.liveness({
      publicMerchantKey: returnConfigVariable('REACT_APP_YOUVERIFY_PUBLIC_MERCHANT_KEY'),
      dev: false,
      personalInformation: {
        firstName: `${userDetails.firstName}`,
      },
      appearance: {
        greeting:
          "We will need to perform a liveness test. It will only take a moment.",
        actionText: "Perform Liveness Test",
        buttonBackgroundColor: "#46B2C8",
        buttonTextColor: "#ffffff",
        primaryColor: "#46B2C8",
      },
      onSuccess: (data) => {
        
        
        toggleCamera("parentPicture", true);
        // Handle successful liveness check, e.g., update UI or send data to the server
      },
      onFailure: () => {
        

        // Handle liveness check failure
      },
      onClose: () => {
        

        // Handle modal closure
      },
    });

    try {
      // Initialize the Liveness Check module
      livenessCheckModule.initialize();

      // Start the liveness check process when the component mounts
      livenessCheckModule.start();
    } catch (error) {
      console.error("Error initializing Liveness Check:", error);
      // Handle initialization error
    }

    // Cleanup function to be called when the component unmounts
    return () => {
      // You can add cleanup logic here if needed
    };
  };

  return (
    <div>
      {showCamera && (
        <div style={{ overflowX: "scroll" }} className="pt-2">
          <CameraComponent
            onTakePhoto={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
            onCameraError={(error) => {
              handleCameraError(error);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            idealResolution={{ width: 640, height: 480 }}
            imageType={IMAGE_TYPES.PNG}
            imageCompression={0.97}
            isMaxResolution={false}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStop={() => {
              handleCameraStop();
            }}
            onCameraStart={() => {
              handleCameraStart();
            }}
          />
        </div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl-1 pr-1 ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">
              Document upload
            </h4>
            <p className="text-center">
              <small>
                The file format should be JPEG, PNG or PDF (max size:2mb)
              </small>
            </p>

            <div className="row mr-3 mb-3">
              {!minorImageUrl ? (
                <div className="col-sm-6 row">
                  <div className="col-sm-6">
                    <div className="col-md-6">
                      <label
                        htmlFor="firstname"
                        className="label_text2 d-inline text-nowrap font-weight-bold"
                      >
                        Passport photo of minor
                        <small className="text-danger">*</small>
                      </label>
                      <br />
                      <label
                        className="cursor-pointer"
                        htmlFor="inputTagMinorSelfie"
                      >
                        <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                          {settingMinorImage ? (
                            <div className="center-v">
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            </div>
                          ) : (
                            <React.Fragment>
                              <p className="label_text">
                                Click or drag <br /> and drop file
                              </p>
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </React.Fragment>
                          )}
                        </div>
                        <input
                          onChange={(e) => handleFileUpload(e, "minorSelfie")}
                          id="inputTagMinorSelfie"
                          className="input-file-type"
                          type="file"
                          name="file"
                          accept="image/png, image/jpg, image/jpeg"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("minorSelfie")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {minorImageUrl.length > 0 && (
                          <img
                            src={minorImageBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ------------- */}

              {!imageUrl ? (
                <React.Fragment>
                  <div className="col-sm-6 row">
                    <div className="col-sm-6">
                      <div className="col-md-6">
                        <label
                          htmlFor="firstname"
                          className="label_text2 text-nowrap font-weight-bold"
                        >
                          Take/Upload live picture of parent or guardian
                        </label>
                        <br />
                        <label
                          className="cursor-pointer"
                          htmlFor="inputTagImage"
                        >
                          <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                            {settingImage ? (
                              <div className="center-v">
                                <div
                                  className="spinner-border text-danger"
                                  role="status"
                                >
                                  <span className="sr-only"></span>
                                </div>
                              </div>
                            ) : (
                              <React.Fragment>
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                                <img
                                  className="img-fluid"
                                  src={uploadArrow}
                                  alt=""
                                />
                              </React.Fragment>
                            )}
                          </div>
                          <input
                            onChange={(e) =>
                              handleFileUpload(e, "parentPicture")
                            }
                            id="inputTagImage"
                            className="input-file-type"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="col-md-6 mt-4">
                        {/* <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2" onClick={() => toggleCamera('parentPicture', true)}> */}
                        <div
                          className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2"
                          onClick={LivenessCheckClick}
                        >
                          <p className="label_text">
                            Take live
                            <br />
                            picture
                          </p>
                          <img className="img-fluid" src={camera} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <div className="col-md-6">
                  {settingImage ? (
                    <div className="center-v">
                      <div className="spinner-border text-danger" role="status">
                        <span className="sr-only"></span>
                      </div>
                    </div>
                  ) : (
                    <div className="img-upload-success-div">
                      <div className="close-icon-signature-div">
                        <div className="close-icon-img cursor-pointer">
                          <img
                            src={closeIcon}
                            onClick={() => clearImage("parentPicture")}
                          ></img>
                        </div>
                        <div className="signature-img-div">
                          {imageUrl.length > 0 && (
                            <img
                              src={imageBase64}
                              width="70%"
                              height="120px"
                              style={{ zIndex: 1, margin: "auto" }}
                            ></img>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="row">
              {!idCardUrl ? (
                <div className="col-sm-6 row">
                  <div className="col-sm-6 mt-2">
                    <div className="col-md-6">
                      <label
                        htmlFor="firstname"
                        className="label_text2 text-nowrap font-weight-bold"
                      >
                        Front page of ID card of Parent/Guardian
                        <small className="text-danger">*</small>
                      </label>
                      <br />
                      <label
                        className="cursor-pointer"
                        htmlFor="parentFrontPageId"
                      >
                        <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                          {settingIdCardImage ? (
                            <div className="center-v">
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            </div>
                          ) : (
                            <React.Fragment>
                              <p className="label_text">
                                Click or drag <br /> and drop file
                              </p>
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </React.Fragment>
                          )}
                        </div>
                        <input
                          onChange={(e) =>
                            handleFileUpload(e, "parentFrontPageId")
                          }
                          id="parentFrontPageId"
                          className="input-file-type"
                          type="file"
                          name="file"
                          accept="image/png, image/jpg, image/jpeg"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("parentFrontPageId")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {idCardUrl.length > 0 && (
                          <img
                            src={idCardBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* -------- */}

              {!minorIdentityUrl ? (
                <div className="col-xl-6">
                  <div className="col-lg-12 ml-n3">
                    <label
                      htmlFor="firstname"
                      className="label_text2 text-nowrap font-weight-bold"
                    >
                      Scanned copy of Minor's Birth certificate/NIN <br />
                      /International passport
                      <small className="text-danger">*</small>
                    </label>
                    <br />
                    <label className="cursor-pointer" htmlFor="minorIdentity">
                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                        {settingMinorIdentityImage ? (
                          <div className="center-v">
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            <p className="label_text">
                              Click or drag <br /> and drop file
                            </p>
                            <img
                              className="img-fluid"
                              src={uploadArrow}
                              alt=""
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <input
                        onChange={(e) => handleFileUpload(e, "minorIdentity")}
                        id="minorIdentity"
                        className="input-file-type"
                        type="file"
                        name="file"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                    </label>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("minorIdentity")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {minorIdentityUrl.length > 0 && (
                          <img
                            src={minorIdentityBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="row mb-4">
              {!signatureImageUrl ? (
                <div className="col-md-6 mt-2">
                  <div className="col-md-6">
                    <label
                      htmlFor="firstname"
                      className="label_text2 text-nowrap font-weight-bold"
                    >
                      Signature of Parent/Guardian
                    </label>
                    <br />
                    <label className="cursor-pointer" htmlFor="parentSignature">
                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                        {settingSignatureImage ? (
                          <div className="center-v">
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            <p className="label_text">
                              Click or drag <br /> and drop file
                            </p>
                            <img
                              className="img-fluid"
                              src={uploadArrow}
                              alt=""
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <input
                        onChange={(e) => handleFileUpload(e, "parentSignature")}
                        id="parentSignature"
                        className="input-file-type"
                        type="file"
                        name="file"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                    </label>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("parentSignature")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {signatureImageUrl.length > 0 && (
                          <img
                            src={signatureImageBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              {/* {!utilityBillImageUrl ?

<div className="col-md-6">
  <div className="col-md-6 mt-4">
    <label htmlFor="firstname" className="label_text2 d-inline text-nowrap">Utilty Bill</label><br />
    <label className="cursor-pointer" htmlFor="inputTagUtilityBillId">
      <div className="pic_upload2 d-flex justify-content-between font-weight-bold pt-3 pr-3 px-2">
        {settingutilityBillImage ?
          <div className='center-v'>
            <div className="spinner-border text-danger" role="status">
              <span className="sr-only"></span>
            </div>
          </div> :

          <React.Fragment>
            <p className="label_text">Click or drag <br /> and drop file</p>
            <img className="img-fluid" src={uploadArrow} alt="" />
          </React.Fragment>
        }
      </div>
      <input onChange={(e) => handleFileUpload(e, 'utilityBill')} id="inputTagUtilityBillId" className="input-file-type" type="file" accept="image/png, image/jpg, image/jpeg" />
    </label>

  </div>

</div>

:

<div className="col-md-6">
  <div className="img-upload-success-div">
    <div className="close-icon-signature-div">
      <div className="close-icon-img cursor-pointer">
        <img src={closeIcon} onClick={() => clearImage('utility-bill')}></img>
      </div>
      <div className="signature-img-div" style={{
        marginTop: "20px"
      }}>
        {utilityBillImageUrl && (
          <img src={utilityBillImageBase64} width="70%" height="120px" style={{ zIndex: 1, margin: 'auto' }}></img>
        )}

      </div>
    </div>

  </div>
</div>
} */}
              <FileUpload
                id={"inputTagUtilityBillId"}
                clearImage={() => clearImage("utility-bill")}
                fileUrl={utilityBillImageUrl}
                fileUrlImageBase64={utilityBillImageBase64}
                handleFileUpload={(e) => handleFileUpload(e, "utilityBill")}
                settingFileImageUrl={settingutilityBillImage}
                htmlFor={"inputTagUtilityBillId"}
                tag="Utility Bill"
              />
            </div>
          </div>

          <div className="row mt-3 ml-1">
            <div className="col form-group">
              <label htmlFor="branch domicilation" className="label_text">
                Branch of account domiciliation
                <span className="text-danger">*</span>
              </label>
              <Select
                options={mappedBranches}
                value={selectedBranch}
                onChange={handleSelectBranch}
              />
            </div>
          </div>

          <div className="row container mt-3 ml-1">
            <label htmlFor="branch domicilation" className="label_text mb-3">
              Select value-added services
            </label>

            {/* <div className="custom-control custom-checkbox input-group mb-2">
                <input name="smsAlertValueAddedService" onChange={formik.handleChange} value={formik.values.smsAlertValueAddedService} type="checkbox" className="custom-control-input" id="checkbox1" checked />
                <label className="custom-control-label pl-3" htmlFor="checkbox1">SMS alert</label>
              </div> */}
            {/* <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                <input name="emailAlertValueAddedService" onChange={formik.handleChange} value={formik.values.emailAlertValueAddedService} type="checkbox" className="custom-control-input" id="checkbox2" checked />
                <label className="custom-control-label pl-3" htmlFor="checkbox2">Email alert</label>
              </div> */}
            <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
              <input
                name="debitCardValueAddedService"
                onChange={formik.handleChange}
                value={formik.values.debitCardValueAddedService}
                type="checkbox"
                className="custom-control-input"
                id="checkbox3"
              />
              <label className="custom-control-label pl-3" htmlFor="checkbox3">
                <b>
                  {" "}
                  Debit card (Verve/Mastercard) - Click here, if you do not want
                  a debit card
                </b>
              </label>
              {/* <label className="custom-control-label pl-3" htmlFor="checkbox3"><b> Debit card (Verve/Mastercard)- Click to select debit card (If you requested a debit card during account opening, the card will be delivered to you within 3-7 working days, the cost of the card and delivery (N2,075) will be passed to your billing account.)</b></label> */}
            </div>

            {!formik.values.debitCardValueAddedService && (
              <div className="row container" id="dvPassport">
                <div className="col-md-3 form-group">
                  <div className="custom-control custom-radio input-group mb-2">
                    <input
                      name="debitCardType"
                      onChange={formik.handleChange}
                      value="verve"
                      type="radio"
                      className="custom-control-input debit-card-radio-input"
                      id="rad1"
                      checked={formik.values.debitCardType === "verve"}
                    />
                    <label className="custom-control-label pl-3" htmlFor="rad1">
                      Verve
                    </label>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <div className="custom-control custom-radio input-group mb-2">
                    <input
                      name="debitCardType"
                      onChange={formik.handleChange}
                      value="master_card"
                      type="radio"
                      className="custom-control-input debit-card-radio-input"
                      id="rad2"
                      checked={formik.values.debitCardType === "master_card"}
                    />
                    <label className="custom-control-label pl-3" htmlFor="rad2">
                      MasterCard
                    </label>
                  </div>
                </div>
                <div className="col-md-5 mt-n3">
                  <div className="bvn_val mb-2 " id="fader">
                    <img src={Icon_L} alt="" />
                    <small className="text-danger ml-3 text-nowrap">
                      . The card will be delivered to <br /> your residential
                      address
                    </small>
                  </div>
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Debit Card Delivery Address
                  </label>
                  <input
                    name="debitCardDeliveryAddress"
                    onChange={formik.handleChange}
                    value={formik.values.debitCardDeliveryAddress}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter Debit Card Address "
                  />
                </div>
              </div>
            )}

            <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
              <input
                name="terms"
                onChange={formik.handleChange}
                value={formik.values.terms}
                type="checkbox"
                className="custom-control-input"
                id="checkbox4"
              />
              <label className="custom-control-label pl-3" htmlFor="checkbox5">
                By checking this box, you have accepted the{" "}
                <span>
                  <a
                    className="text-danger cursor-pointer"
                    href={links.termsAndConditionsPDF}
                    target="_blank"
                  >
                    <u>Terms and conditions</u>
                  </a>
                </span>
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep("update-detail");
                }}
                className="btn btn-outline-gold mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {updating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button type="submit" className="btn btn-filled-red">
                Complete
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExUploadDocumentsMinorSavings;
